import { Link } from 'react-router-dom'
import { api, useApi } from '../api/queries'
import type { MetaResponse } from '../api/types'

export function HomePage() {
  const meta = useApi<MetaResponse>(['meta'], () => api.GET('/api/v1/meta', {}))

  return (
    <section className="prose hero">
      <h1>Formula One history, with the rules changed</h1>
      <p>
        Every World Championship result since 1950, with each season’s standings recomputed from
        the rules it actually used: the points table, which results counted, the half points and
        the penalties. That replay reproduces the official champions, so it can be trusted when
        the rules are changed.
      </p>
      <p>
        Change them, and a removed driver is not just hidden: the field behind moves up race by
        race, scoring the points for its new positions, and the championship is decided again.
      </p>
      <p>
        <Link to="/seasons">Seasons</Link>, <Link to="/drivers">Drivers</Link> and{' '}
        <Link to="/constructors">Constructors</Link> are the record as it stands.{' '}
        <Link to="/f2/championship">F2 rules</Link> replays it under Formula 2’s rule, where a
        champion moves up and never returns, <Link to="/f15/championship">F1.5 rules</Link>{' '}
        without each season’s fastest teams, and <Link to="/reverse/championship">Reverse</Link>{' '}
        with every finishing order upside down. <Link to="/ban">With Ban</Link> decides it all
        again as if the drivers, teams and Grands Prix you choose had never existed, and{' '}
        <Link to="/points">Custom Points</Link> on a points table you make up.{' '}
        <Link to="/qualifying/championship">Qualifying</Link> scores only the grid, on each
        season’s own table, and <Link to="/fp/championship">FP Championship</Link> only free
        practice, every session a race of its own. <Link to="/compare">Compare</Link> sets any
        two of them side by side.
      </p>
      {meta.data ? (
        <p className="muted">
          {meta.data.seasons} seasons · {meta.data.races.toLocaleString()} races ·{' '}
          {meta.data.results.toLocaleString()} results
          {meta.data.source_version
            ? ` · ${meta.data.source_name} ${meta.data.source_version}`
            : ''}
          {meta.data.latest_race_with_results
            ? ` · latest result ${meta.data.latest_race_with_results}`
            : ''}
        </p>
      ) : null}
    </section>
  )
}
